module.exports = __webpack_public_path__ + "img/Menu-08.a49c2603.png";